import { PixiContext } from "common/pixi";
import { ReesizeEventHandler } from "common/resize";
import { Sheet } from "common/sheet";
import * as PIXI from "pixi.js";
import * as R from "ramda";
import { calculateScreen, letterbox, onScreenUpdate } from "../screen";
import { BackgroundPersonAnimator } from "./backgroundPersonAnimator";
import { BackgroundPersonSoundPlayer } from "./backgroundPersonSoundPlayer";
import { BackgroundSoundPlayer } from "./backgroundSoundPlayer";
import { AButton, Background, BackgroundPerson, BButton, CButton, Grey, Person, Shade, Title, } from "./resources";
import * as Video2Interaction from "./video2Interaction";
import * as WalkInteraction from "./walkInteraction";
export class Scene {
    async start({ sound, parentSelector, }) {
        const resizer = new ReesizeEventHandler();
        letterbox(resizer);
        console.log("createapplication");
        const app = createApplication(parentSelector);
        const pixiContext = new PixiContext(app);
        console.log("loadalltextures");
        const elements = await loadAllTextures(pixiContext, app);
        const container = addSpritesToScene(Object.assign({ app }, elements));
        elements.cButton.idleEventListeners.add({
            stop: () => {
                elements.aButton.cancelIdle();
                elements.bButton.cancelIdle();
            },
            left: () => {
                elements.aButton.idleAnimate();
            },
            right: () => {
                elements.bButton.idleAnimate();
            },
        });
        const ticker = app.ticker;
        ticker.speed = 1;
        const backgroundPlayer = new BackgroundSoundPlayer(sound);
        const backgroundpersonSoundPlayer = new BackgroundPersonSoundPlayer(sound);
        const backgroundPersonAnimator = new BackgroundPersonAnimator({
            backgroundPerson: elements.backgroundPerson,
            pixiContext,
        });
        await Video2Interaction.run(Object.assign(Object.assign({}, elements), { sound,
            backgroundPlayer, root: container.root, pixiContext,
            backgroundPersonAnimator }));
        ticker.speed = 1;
        await WalkInteraction.run(Object.assign(Object.assign({}, elements), { sound,
            backgroundPlayer, container: container.sceneContainer, pixiContext,
            backgroundpersonSoundPlayer,
            backgroundPersonAnimator }));
        backgroundPersonAnimator.dispose();
        elements.cButton.dispose();
        elements.aButton.dispose();
        elements.bButton.dispose();
        ticker.stop();
        pixiContext.dispose();
        app.destroy(true);
        PIXI.utils.destroyTextureCache();
        $("#pixi-canvas").remove();
        resizer.drop();
        // ticker.speed = 1000;
    }
}
function createApplication(parentSelector) {
    const { screen: { width: screenWidth, height: screenHeight }, viewport: { width: viewportWidth, height: viewportHeight }, } = calculateScreen();
    const app = new PIXI.Application({
        width: viewportWidth,
        height: viewportHeight,
    });
    $(app.view)
        .attr("id", "pixi-canvas")
        .attr("width", viewportWidth)
        .attr("height", viewportHeight)
        .attr("class", "pointer-allow")
        .css("width", screenWidth)
        .css("height", screenHeight);
    $(parentSelector).append(app.view);
    return app;
}
async function loadAllTextures(pixiContext, app) {
    const makePath = (name) => `/resources/1-run/${name}`;
    const backgroundSheets = await Promise.all(R.map((index) => {
        return Sheet.load(makePath(`sheet${index}.png`), makePath(`sheet${index}.json`));
    })(R.range(0, 6)));
    const personSheets = await Promise.all(R.map((index) => {
        return Sheet.load(makePath(`sheet-person${index}.png`), makePath(`sheet-person${index}.json`));
    })(R.range(0, 7)));
    const person = new Person(pixiContext, personSheets);
    const shade = new Shade(pixiContext, backgroundSheets);
    person.listeners.add(shade.walkListener);
    return {
        background: new Background(pixiContext, backgroundSheets),
        backgroundPerson: new BackgroundPerson(pixiContext, personSheets),
        shade,
        person,
        title: new Title(pixiContext, backgroundSheets),
        grey: new Grey(app),
        aButton: new AButton(pixiContext, backgroundSheets),
        bButton: new BButton(pixiContext, backgroundSheets),
        cButton: new CButton(pixiContext, backgroundSheets),
    };
}
function createCenterContainer() {
    const { viewport: { width, height }, } = calculateScreen();
    const centerContainer = new PIXI.Container();
    centerContainer.position.x = width / 2;
    centerContainer.position.y = height / 2;
    onScreenUpdate(({ viewport: { width, height } }) => {
        centerContainer.position.x = width / 2;
        centerContainer.position.y = height / 2;
    });
    return centerContainer;
}
function addSpritesToScene({ background, shade, person, app, grey, title, aButton, bButton, cButton, backgroundPerson, }) {
    const centerContainer = createCenterContainer();
    app.stage.addChild(centerContainer);
    const rootContainer = new PIXI.Container();
    centerContainer.addChild(rootContainer);
    const sceneContainer = new PIXI.Container();
    rootContainer.addChild(sceneContainer);
    sceneContainer.addChild(background.sprite);
    sceneContainer.addChild(backgroundPerson.leftSprite);
    sceneContainer.addChild(backgroundPerson.rightSprite);
    sceneContainer.addChild(person.sprite);
    sceneContainer.addChild(shade.sprite);
    rootContainer.addChild(grey.sprite);
    rootContainer.addChild(title.sprite);
    rootContainer.addChild(aButton.sprite);
    rootContainer.addChild(bButton.sprite);
    rootContainer.addChild(cButton.sprite);
    return {
        sceneContainer,
        root: rootContainer,
    };
}
//# sourceMappingURL=main.js.map